import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocumentsService {

  constructor(private httpClient: HttpClient) { }

  downloadFile(filePath: string): Observable<any> {
    return this.httpClient.post("/Document/downloadDocument", { fileName: filePath }, { responseType: 'blob'});
  }
}
